import { useState } from "react";
import { Mail, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";

export function NewsletterTest({ endpoint = "/admin/newsletter/test", name = "Wochenrückblick", info = "geht jeden Sonntag um 10 Uhr automatisch an alle, die ihn nicht abbestellt haben.", testid = "admin-newsletter" }) {
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try { const { data } = await api.post(endpoint); toast.success(`Test-Mail „${name}“ an ${data.to} gesendet`); }
    catch (e) { toast.error(formatErr(e)); } finally { setBusy(false); }
  };
  return (
    <div className="flex flex-wrap items-center gap-3 p-4 rounded-2xl bg-white border border-pink-100" data-testid={testid}>
      <Mail className="w-5 h-5 text-rose-500 shrink-0" />
      <p className="flex-1 min-w-[12rem] text-sm text-slate-600"><b>{name}</b> {info}</p>
      <button onClick={send} disabled={busy} data-testid={`${testid}-test`} className="px-4 h-9 rounded-full pink-gradient text-white text-xs font-bold inline-flex items-center gap-1.5 disabled:opacity-50">{busy && <Loader2 className="w-3.5 h-3.5 animate-spin" />} Test an mich senden</button>
    </div>
  );
}
